var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ConnectionNames } from "../../Contracts";
import { ConfigStore, getUserId } from "..";
/**
 * Config for channel path and request method type.
 *
 * @namespace
 * @property {object} ConnectionNames - excluding Sportsbook
 * @property {object} ConnectionNames.MessageChannels
 * @property {string} ConnectionNames.MessageChannels.path
 * @property {HTTPRequestMethod} [ConnectionNames.MessageChannels.method="GET"]
 */
export const ChannelsConfig = {
    [ConnectionNames.betslip]: {
        CalculateBets: {
            path: "/betting/calculate/regularbets",
            method: "POST"
        },
        CalculateYourbetBets: {
            path: "/betting/calculate/yourbet",
            method: "POST"
        },
        PlaceBets: {
            path: "/betting/purchases",
            method: "POST"
        },
        UpdatePurchases: {
            path: "/betting/purchases",
            method: "PUT"
        },
        GetPurchases: {
            path: "/betting/purchases"
        }
    },
    [ConnectionNames.realityCheck]: {
        GetSettings: {
            path: "/interval"
        },
        SaveSettings: {
            path: "/interval",
            method: "POST"
        },
        GetWageringInformation: {
            path: "/wageringinformation"
        },
    },
    [ConnectionNames.player]: {
        GetPlayer: {
            path: params => ({
                channel: `/players/${getUserId(ConfigStore.config.connections.jwt)}`,
                params
            })
        },
        GetLimitsHistory: {
            path: params => ({
                channel: `/players/${getUserId(ConfigStore.config.connections.jwt)}/limitshistory`,
                params
            })
        }
    },
    [ConnectionNames.betsReporting]: {
        GetSettledBets: {
            path: "/bets/settled"
        }
    },
    [ConnectionNames.casino]: {
        GetCategories: {
            path: "/categories"
        },
        GetFreespins: {
            path: "/freespins"
        },
        GetGames: {
            path: (_a) => {
                var { categoryId, gameCollectionId } = _a, params = __rest(_a, ["categoryId", "gameCollectionId"]);
                return ({
                    channel: `/categories/${categoryId}/collections/${gameCollectionId}`,
                    params
                });
            }
        },
        GetLaunchParams: {
            path: "/game/launchParams"
        },
    },
    [ConnectionNames.captor]: {
        ReportsMetaData: {
            path: "/reportsmetadata",
            method: "POST"
        },
        Report: {
            path: "/report",
            method: "POST"
        },
        AnnualReport: {
            path: "/annualreport",
            method: "POST"
        },
    },
    [ConnectionNames.search]: {
        Search: {
            path: "/search"
        },
        PersonalizedEvents: {
            path: "/events/getpersonalizedpreliveevents",
            method: "POST"
        }
    },
    [ConnectionNames.casinoPlayerActivity]: {
        GetLastBetAge: {
            path: "/"
        }
    }
};
//# sourceMappingURL=index.js.map